import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/demo/3d/ux")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
